import globalFilter from '../../../tools/globalFilter'

export default function (state, payload) {
  let selectedMaerkte = payload.selectedItems
  return {
    ...state,
    selectedMaerkte: selectedMaerkte,
  }
}
